import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import {
  AgrPageDetailModule,
  AgrPageToolbarModule,
  AgrSummaryCardModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { AgrTableModule } from '@next/core-lib/table';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { ReferenceSchemeEffects } from './store/reference-scheme.effects';
import { SharedModule } from '../shared/shared.module';
import { CreateReferenceSchemeComponent } from './components/create-reference-scheme/create-reference-scheme.component';
import { ReferenceSchemeOverviewComponent } from './components/reference-scheme-overview/reference-scheme-overview.component';
import { ReferenceSchemeRouterComponent } from './components/reference-scheme-router/reference-scheme-router.component';
import { GetReferenceSchemeByIdResolver } from './resolvers/get-reference-scheme-by-id.resolver';
import { ReferenceSchemeOverviewResolver } from './resolvers/reference-scheme-overview.resolver';
import { ReferenceSchemeService } from './services/reference-scheme.service';
import * as referenceSchemeReducer from './store/reference-scheme.reducer';

@NgModule({
  declarations: [
    CreateReferenceSchemeComponent,
    ReferenceSchemeOverviewComponent,
    ReferenceSchemeRouterComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    AgrPageToolbarModule,
    AgrTableModule,
    MatSlideToggleModule,
    MatButtonModule,
    AgrDialogModule,
    AgrPageDetailModule,
    AgrFormModule,
    MatFormFieldModule,
    MatInputModule,
    AgrSummaryCardModule,
    MatSelectModule,
  ],
  providers: [
    ReferenceSchemeService,
    ReferenceSchemeOverviewResolver,
    GetReferenceSchemeByIdResolver,
    provideState('referenceSchemeModule', referenceSchemeReducer.reducer),
    provideEffects([ReferenceSchemeEffects]),
  ],
})
export class ReferenceSchemeModule {}
